import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerDiscountAll: [],
  insurerDiscount: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerDiscountSlice = createSlice({
  name: "insurerDiscount",
  initialState,
  reducers: {
    setInsurerDiscountAll: (state, action) => {
      state.insurerDiscountAll = action.payload;
    },
    setInsurerDiscount: (state, action) => {
      state.insurerDiscount = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerDiscountAll,
  setInsurerDiscount,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerDiscountSlice.actions;

export default insurerDiscountSlice.reducer;
